import React from 'react';
import { Form, Input, Select, InputNumber, Radio, message, DatePicker, Upload, Icon, Popconfirm, notification } from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../components/Modal';
import { CustomRow, CustomCol } from '../../components/Custom';
import { post, config, postFrom, uploadEnclosure } from '../../axios';
import { customerType as customerTypes, dicHouseStatus, credentialType, paymentDate, dicContractSource, contractType } from '../../axios/dictionaries';
import ChooseGoods from './ChooseGoods';
import moment from 'moment';
import { handleDeepCopy } from '../../utils';

const Option = Select.Option;
const { TextArea } = Input;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class LeaseSigning extends React.Component {
    constructor() {
        super();

        this.initState = { //需要在关闭页面重置的属性
            title: "",
            visible: false,
            loading: false,
            data: {},
            departmentData: [], //商户下的部门
            userData: [], //部门下的人员
            contractData: {}, //当前房源关联的合同
            customerType: 2, //租客类型-默认个人
            source: 1, //来源
            signType: 1, //签约类型
            createElectronicContract: 'true', //创建电子合同
            downloadUrl: '', //合同模板地址
        };

        this.state = {
            ...handleDeepCopy(this.initState),
        }
    }
    componentDidMount() {
        this.props.onRef(this);
        let loginData = Cookies.get('loginData');
        if (loginData) {
            this.loginData = JSON.parse(loginData);
        }
    }

    loadPack = (data) => {
        this.setState({ title: data.id ? '续签' : '签约' })
        if (this.loginData) {
            this.setState({ data, visible: true }, () => {
                this.postContractTemplateGet();
                this.postDepartmentGet();
                this.postUserGet();
                if (data.id) {
                    this.postContractGet(data.id,(firstLastRentType)=>{
                        console.log(firstLastRentType);
                        this.handleFirstLastRentTypeChange(firstLastRentType);
                    });

                }
            });
        } else {
            message.error('未登录！');
        }
    }


 
    postContractGet = (rentContractId,cb) => {

        const format = (res) => {
            res.paperAttachList = res.paperAttachList ? this.formatUpload(res.paperAttachList) : []
            res.attachList = res.attachList ? this.formatUpload(res.attachList) : []
           
            res.beginDate = moment(res.endDate).clone().add(1, 'days')
            res.endDate = res.beginDate.clone().add(3, 'months').subtract(1, 'days')
            res.firstRentStartDate = res.firstRentStartDate ? moment(res.firstRentStartDate) : undefined
            res.firstRentEndDate = res.firstRentEndDate ? moment(res.firstRentEndDate) : undefined
            res.lastRentStartDate = res.lastRentStartDate ? moment(res.lastRentStartDate) : undefined
            res.lastRentEndDate = res.lastRentEndDate ? moment(res.lastRentEndDate) : undefined
            return res
        }


        postFrom({ url: config.API_rentcontract_getRentContractById, data: { rentContractId } }).then(res => {

            this.setState(state => {
                // 处理
                res = format(res)
                state.data = { ...state.data, ...res }


                return state
            },()=>{
                if(cb){
                    cb(res.firstLastRentType)
                }
            })

        })
    }

    postContractTemplateGet = () => { //获取当前房源关联的合同模板
        postFrom({ url: config.API_contracttemplate_findByHouseId, data: { houseId: this.state.data.houseId } }).then(res => {
            if (res) {
                this.setState({ contractData: res });
            }
        }).catch(err => {
            message.error(err.message || '获取部门列表失败');
            notification.error({
                message: '错误通知',
                description: '当前房源关联电子合同失败，不可签约.',
            });
        })
    }

    postDepartmentGet = () => { //获取当前商户的部门
        postFrom({ url: config.API_merchantdepartment_findAll, data: { merchantId: this.loginData.merchantId || 0 } }).then(res => {
            this.setState({ departmentData: res });
        }).catch(err => {
            message.error(err.message || '获取部门列表失败');
        })
    }

    postUserGet = (departmentId) => { //获取当前部门下的人员
        let data = {};
        if (this.loginData.merchantId) {
            data = {
                merchantId: this.loginData.merchantId,
                merchantUserId: this.loginData.id,
                merchantDepartmentId: departmentId || this.loginData.departmentId,
            }
        }
        postFrom({ url: config.API_merchantuser_findList, data }).then(res => {
            this.setState({ userData: res });
        }).catch(err => {
            message.error(err.message || '获取人员列表失败');
        })
    }

    formatUpload = (list =[]) => { // 格式化上传格式数据
        if (!list)  return

        const transfer = (e) => {
            return {
                name: e.name || e.attach_name || e.fileName, 
                id: e.id || e.attach_id, 
                url: e.url || e.attach_url || e.fileUrl
            }
        }
        if (list instanceof Array) {
            return list.map(e => transfer(e))
        }
        return transfer(list)
       
    }

    uploadEnclosure = (name, res) => { //上传附件
        let { data } = this.state;
        if (data.attachList instanceof Array) {
            data.attachList.push({ name, id: res.attach_id, url: res.attach_url });
        } else {
            data.attachList = [{ name, id: res.attach_id, url: res.attach_url }];
        }
        this.setState({ data });
    }

    uploadContract = (name, res) => { //上传合同照片
        let { data } = this.state;
        if (data.paperAttachList instanceof Array) {
            data.paperAttachList.push({ name, id: res.attach_id, url: res.attach_url });
        } else {
            data.paperAttachList = [{ name, id: res.attach_id, url: res.attach_url }];
        }
        this.setState({ data });
    }

    startDisabledDate = (current) => { //限制零散租期的范围
        let { beginDate, endDate } = this.props.form.getFieldsValue();
        let end2 = endDate.clone().add(1, 'days'); //把end克隆出来操作
        return current && (current < beginDate || current > end2);
    }

    handleGoodsChange = () => { //设置房间物品
        let { data } = this.state;
        this.chooseGoodsRef.loadPack(data.furnitureList).then(res => {
            let { data } = this.state;
            data.furnitureList = res;
            this.setState({ data });
        });
    }

    handleFirstLastRentTypeChange = (e) => {
     
        if (e === 2) {
            const { setFieldsValue, getFieldsValue } = this.props.form
            const { beginDate, endDate } = getFieldsValue()
            setTimeout(() => {
                setFieldsValue({ firstRentStartDate: beginDate, lastRentEndDate: endDate  })
            }, 300);
        }
         
    }

    handleCancel = () => { //关闭页面
        this.setState({ visible: false, ...handleDeepCopy(this.initState) });
    }

    handleDeleteAttach = (index) => { //删除附件
        let { data } = this.state;
        data.attachList.splice(index, 1);
        this.setState({ data });
    }


    handleDeleteContract = (index) => { //删除合同照片
        let { data } = this.state;
        data.paperAttachList.splice(index, 1);
        this.setState({ data });
    }

    handleGetPreviewUrl = () => { // 获取合同预览地址
        let { contractData } = this.state;
        if (contractData.id) {
            let data = { rentContractId: contractData.id };
            postFrom({ url: config.API_rentcontract_getPreviewUrl, data }).then(res => {
                this.setState({ downloadUrl: res.url }, () => {
                    this.downloadRef.click();
                });
            }).catch(err => {
                message.error(err.message || '获取预览合同失败');
            })
        } else {
            message.error('未查询到合同模板')
        }
    }


    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if(error && error.customerName && error.customerName.errors.length > 0 ) {
                const name = values.customerType === 1 ? '企业名称' : '租客姓名'
                message.warning('请输入' + name)
                return
            }
            if(error && error.customerIdNumber && error.customerIdNumber.errors.length > 0 ) {
                const numText = values.customerType === 1 ? '营业执照' : '租客证件号码'
                message.warning('请输入' + numText)
                return
            }
            // if (values.beginDate.unix() > values.endDate.unix()) {
            //     message.warning('到期日不能提前于起租日')
            //     return 
            // }
            if (!error) {
                if (!this.loginData) {
                    message.error('未登录')
                    return
                }
                this.setState({ loading: true });
                values = { ...this.state.data, ...values };
                values.beginDate = values.beginDate ? moment(values.beginDate).format('YYYY-MM-DD') : '';
                values.endDate = values.endDate ? moment(values.endDate).format('YYYY-MM-DD') : '';
                values.signDate = values.signDate ? moment(values.signDate).format('YYYY-MM-DD') : '';
                values.billBeginDate = values.billBeginDate ? moment(values.billBeginDate).format('YYYY-MM-DD') : '';
                values.firstRentStartDate = values.firstRentStartDate ? moment(values.firstRentStartDate).format('YYYY-MM-DD') : '';
                values.firstRentEndDate = values.firstRentEndDate ? moment(values.firstRentEndDate).format('YYYY-MM-DD') : '';
                values.lastRentStartDate = values.lastRentStartDate ? moment(values.lastRentStartDate).format('YYYY-MM-DD') : '';
                values.lastRentEndDate = values.lastRentEndDate ? moment(values.lastRentEndDate).format('YYYY-MM-DD') : '';
                if (values.createElectronicContract === "true") //是否生成电子合同
                    values.createElectronicContract = true;
                else if (values.createElectronicContract === "false")
                    values.createElectronicContract = false;

                if (this.state.data.attachList instanceof Array) {
                    values.attachList = this.state.data.attachList.map((item) => ({ id: item.id }));
                }
                
                if (this.state.data.paperAttachList instanceof Array) {
                    values.paperAttachList = this.state.data.paperAttachList.map((item) => ({ id: item.id }));
                }
                if (values.id) {
                    values.oldRentContractId = values.id
                }

                post({ url: config.API_rentcontract_create, data: values }).then(res => {
                    message.success('签约成功');
                    this.handleCancel();
                }).catch(err => {
                    message.error(err.message || '签约失败');
                    this.setState({ loading: false });
                })
            }
        })
    }

    // 计算零散租期的金额
    computeScatteredMoney = ({ firstRentEndDate, lastRentStartDate, monthlyFee, networkFee, propertyFee }) => {
        // 需要收集的字段
        const { getFieldsValue, setFieldsValue } = this.props.form;
        if (firstRentEndDate) {
            // 选中了首期
            let collect = ['firstRentStartDate', 'monthlyFee', 'networkFee', 'propertyFee'];
            let { firstRentStartDate, monthlyFee: monthlyFee1 = 0, networkFee: networkFee1 = 0, propertyFee: propertyFee1 = 0 } = getFieldsValue(collect);
            let days = firstRentStartDate.daysInMonth(); //获取首期月份天数
            let dayNumber = moment(firstRentEndDate.format('YYYY-MM-DD')).diff(moment(firstRentStartDate.format('YYYY-MM-DD')), 'days') + 1;//零散租期总天数
            let dayLyFee = (monthlyFee1 / days * dayNumber).toFixed(2); //每日租金
            let dayNetworkFee = (networkFee1 / days * dayNumber).toFixed(2); //每日网费
            let dayPropertyFee = (propertyFee1 / days * dayNumber).toFixed(2); //每日物业费
            setFieldsValue({ firstRentFee: dayLyFee, firstRentNetworkFee: dayNetworkFee, firstRentPropertyFee: dayPropertyFee });
        } else if (lastRentStartDate) {
            // 选中了末期
            let collect = ['lastRentEndDate', 'monthlyFee', 'networkFee', 'propertyFee'];
            let { lastRentEndDate, monthlyFee: monthlyFee1 = 0, networkFee: networkFee1 = 0, propertyFee: propertyFee1 = 0 } = getFieldsValue(collect);
            let days = lastRentStartDate.daysInMonth(); //获取首期月份天数
            let dayNumber = moment(lastRentEndDate.format('YYYY-MM-DD')).diff(moment(lastRentStartDate.format('YYYY-MM-DD')), 'days') + 1;//零散租期总天数
            let dayLyFee = (monthlyFee1 / days * dayNumber).toFixed(2); //每日租金
            let dayNetworkFee = (networkFee1 / days * dayNumber).toFixed(2); //每日网费
            let dayPropertyFee = (propertyFee1 / days * dayNumber).toFixed(2); //每日物业费
            setFieldsValue({ lastRentFee: dayLyFee, lastRentNetworkFee: dayNetworkFee, lastRentPropertyFee: dayPropertyFee });
        } else if (monthlyFee !== undefined || networkFee !== undefined || propertyFee !== undefined) {
            // 修改时间
            let collect = ['firstRentStartDate', 'firstRentEndDate', 'lastRentStartDate', 'lastRentEndDate', 'monthlyFee', 'networkFee', 'propertyFee'];
            let { firstRentStartDate, firstRentEndDate: firstRentEndDate1, lastRentStartDate: lastRentStartDate1, lastRentEndDate, monthlyFee: monthlyFee1 = 0, networkFee: networkFee1 = 0, propertyFee: propertyFee1 = 0 } = getFieldsValue(collect);
            monthlyFee && (monthlyFee1 = monthlyFee);
            networkFee && (networkFee1 = networkFee);
            propertyFee && (propertyFee1 = propertyFee);
            if (firstRentEndDate1) {
                // 设置首期
                let days = firstRentStartDate.daysInMonth(); //获取首期月份天数
                let dayNumber = moment(firstRentEndDate1.format('YYYY-MM-DD')).diff(moment(firstRentStartDate.format('YYYY-MM-DD')), 'days') + 1;//零散租期总天数
                let dayLyFee = (monthlyFee1 / days * dayNumber).toFixed(2); //每日租金
                let dayNetworkFee = (networkFee1 / days * dayNumber).toFixed(2); //每日网费
                let dayPropertyFee = (propertyFee1 / days * dayNumber).toFixed(2); //每日物业费
                setFieldsValue({ firstRentFee: dayLyFee, firstRentNetworkFee: dayNetworkFee, firstRentPropertyFee: dayPropertyFee });
            }
            if (lastRentStartDate1) {
                // 设置末期
                let days = lastRentStartDate1.daysInMonth(); //获取首期月份天数
                let dayNumber = moment(lastRentEndDate.format('YYYY-MM-DD')).diff(moment(lastRentStartDate1.format('YYYY-MM-DD')), 'days') + 1;//零散租期总天数
                let dayLyFee = (monthlyFee1 / days * dayNumber).toFixed(2); //每日租金
                let dayNetworkFee = (networkFee1 / days * dayNumber).toFixed(2); //每日网费
                let dayPropertyFee = (propertyFee1 / days * dayNumber).toFixed(2); //每日物业费
                setFieldsValue({ lastRentFee: dayLyFee, lastRentNetworkFee: dayNetworkFee, lastRentPropertyFee: dayPropertyFee });
            }
        }
    }



    render() {
        let { form: { getFieldDecorator, getFieldValue, getFieldsValue, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            departmentData,
            userData,
            contractData,
            customerType,
            source,
            signType,
            createElectronicContract,
            downloadUrl,
        } = this.state;
        let newDicHouseStatus = [].concat(dicHouseStatus);
        newDicHouseStatus.splice(1, 1);
        
        const isSetFirstEnd = (getFieldValue('firstLastRentType') || data.firstLastRentType) === 2 // 是否显示零散租期
        const isRenewal = !!this.state.data.id // 是否为续签

        return <ModalDom
            title={title}
            visible={this.state.visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
               >
            <div className="custom">
                <Form>
                    {getFieldDecorator('houseId', {
                        initialValue: data.houseId
                    })(
                        <Input type="hidden" />
                    )}
                    <CustomRow title="房源">
                        <CustomCol label="小区/楼栋" required={false}>
                            {getFieldDecorator('buildingName', {
                                initialValue: data.buildingName
                            })(
                                <Input disabled />
                            )}
                        </CustomCol>
                        <CustomCol label="房间号" required={false}>
                            {getFieldDecorator('buildingName', {
                                initialValue: data.roomNo
                            })(
                                <Input disabled />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <div className="hr" />
                    <CustomRow title="租客" divider>
                        <CustomCol
                            required={'none'}
                            labelStyle={{ padding: 0, borderRight: '1px solid #d9d9d9' }}
                            label={
                                getFieldDecorator('customerType', {
                                    initialValue: data.customerType || customerType
                                })(
                                    <Select
                                        showSearch
                                        placeholder="请选择"
                                        optionFilterProp={'children'}
                                        onChange={(value) => {
                                            this.setState({ customerType: value })
                                        }}
                                        disabled={isRenewal}
                                    >
                                        {customerTypes.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                    </Select>
                                )
                            }
                        >
                            {getFieldDecorator('customerName', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.customerName
                            })(
                                <Input
                                    autoComplete={"off"}
                                    disabled={isRenewal}
                                    placeholder={customerType === 1 ? "工商营业执照上的企业全称" : "请输入"}
                                    maxLength={customerType === 1 ? 20 : 10}
                                />
                            )}
                        </CustomCol>
                        {
                            // 企业
                            customerType === 1
                                ? <CustomCol label="营业执照">
                                    {getFieldDecorator('customerIdNumber', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.customerIdNumber
                                    })(
                                        <Input
                                            autoComplete={"off"}
                                            disabled={isRenewal}
                                            placeholder="统一社会信用代码"
                                        />
                                    )}
                                </CustomCol>
                                // 个人
                                : customerType === 2
                                    ? <React.Fragment>
                                        <CustomCol
                                            required={'none'}
                                            labelStyle={{ width: this.labelWidth, padding: 0, borderRight: '1px solid #d9d9d9' }}
                                            label={
                                                getFieldDecorator('customerCredentialType', {
                                                    initialValue: data.customerCredentialType || 1
                                                })(
                                                    <Select
                                                        dropdownMatchSelectWidth={false}
                                                        showSearch
                                                        placeholder="请选择"
                                                        optionFilterProp={'children'}
                                                        disabled={isRenewal}
                                                    >
                                                        {credentialType.map((item, index) => <Option title={item.title} value={item.value} key={index}>{item.title}</Option>)}
                                                    </Select>
                                                )
                                            }
                                        >
                                            {getFieldDecorator('customerIdNumber', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                                initialValue: data.customerIdNumber
                                            })(
                                                <Input
                                                    autoComplete={"off"}
                                                    disabled={isRenewal}
                                                    placeholder="请输入"
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol label="手机号码">
                                            {getFieldDecorator('customerPhone', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                                initialValue: data.customerPhone
                                            })(
                                                <Input
                                                    disabled={isRenewal}
                                                    autoComplete={"off"}
                                                    placeholder="请输入"
                                                />
                                            )}
                                        </CustomCol>
                                    </React.Fragment>
                                    : null
                        }
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="联系人" required={false}>
                            {getFieldDecorator('linkmanName', {
                                rules: [{
                                    required: false, message: '请输入',
                                }],
                                initialValue: data.linkmanName
                            })(
                                <Input
                                    autoComplete={"off"}
                                    maxLength={10}
                                    disabled={isRenewal}
                                    placeholder="请输入"
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="手机号码" required={false}>
                            {getFieldDecorator('linkmanPhone', {
                                rules: [{
                                    required: false, message: '请输入',
                                }],
                                initialValue: data.linkmanPhone
                            })(
                                <Input
                                    disabled={isRenewal}
                                    autoComplete={"off"}
                                    placeholder="请输入"
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <div className="hr" />
                    <CustomRow title="合同" divider>
                        <CustomCol label="来源">
                            {getFieldDecorator('contractSource', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: isRenewal ? (2) : (data.contractSource || source)
                            })(
                                <Select
                                    showSearch
                                    disabled={isRenewal}
                                    placeholder="请选择"
                                    onChange={(value) => {
                                        this.setState({ source: value })
                                    }}
                                    optionFilterProp={'children'}
                                >
                                    {dicContractSource.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        {
                            source === 4
                                ? <React.Fragment>
                                    <CustomCol label="账单生成日">
                                        {getFieldDecorator('billBeginDate', {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: data.billBeginDate ? moment(data.billBeginDate) : undefined
                                        })(
                                            <DatePicker
                                                placeholder={'请选择'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="创建电子合同">
                                        {getFieldDecorator('createElectronicContract', {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: createElectronicContract
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="请选择"
                                                onChange={(value) => {
                                                    if (value === 'false') {
                                                        this.setState({ createElectronicContract: value, signType: 2 });
                                                        setFieldsValue({ contractType: 2 });
                                                    } else {
                                                        this.setState({ createElectronicContract: value });
                                                    }
                                                }}
                                                optionFilterProp={'children'}
                                            >
                                                <Option value={'true'}>是</Option>
                                                <Option value={'false'}>否</Option>
                                            </Select>
                                        )}
                                    </CustomCol>
                                </React.Fragment>
                                : null
                        }
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="起租日">
                            {getFieldDecorator('beginDate', {
                                rules: [{
                                    required: true, message: '请选择',
                                }],
                                initialValue: data.beginDate ? moment(data.beginDate) : moment()
                            })(
                                <DatePicker
                                    placeholder={'请选择'}
                                    allowClear={false}
                                    disabled={isRenewal}
                                    onChange={(date) => {
                                        if(isSetFirstEnd) {
                                            setFieldsValue({ 'SELECT-RANGE-TIME': undefined, firstRentStartDate: date });
                                            //    ###mark 更新零散租期

                                            const {getFieldsValue} = this.props.form;
                                            let collect = ['firstRentEndDate', 'monthlyFee', 'networkFee', 'propertyFee'];
                                            let {firstRentEndDate} = getFieldsValue(collect);
                                            if (firstRentEndDate) {
                                                this.computeScatteredMoney({firstRentEndDate: firstRentEndDate});
                                            }
                                        }

                                    }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="到期日">
                            {getFieldDecorator('endDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.endDate ? moment(data.endDate) : moment().add(3, 'months').subtract(1, 'days')
                            })(
                                <DatePicker
                                    placeholder={'请选择'}
                                    allowClear={false}
                                    onChange={(date) => {
                                        if(isSetFirstEnd) {
                                            setFieldsValue({ 'SELECT-RANGE-TIME': undefined, lastRentEndDate: date });
                                            // ###mark 更新零散租期
                                           
                                            let collect = ['lastRentStartDate', 'monthlyFee', 'networkFee', 'propertyFee'];
                                            let {lastRentStartDate} = getFieldsValue(collect);
                                            if (lastRentStartDate) {
                                                this.computeScatteredMoney({lastRentStartDate: lastRentStartDate});
                                            }
                                        }
                                    }}
                                />
                            )}
                        </CustomCol>
                        <div className="center" style={{ paddingLeft: '15px', height: '36px' }}>
                            {getFieldDecorator('SELECT-RANGE-TIME', {
                                initialValue: 3
                            })(
                                <RadioGroup
                                    onChange={(e) => {
                                        let endDate = getFieldValue('beginDate').clone().add(e.target.value, 'months').subtract(1, 'days');
                                        setFieldsValue({ endDate});
                                        if(isSetFirstEnd) {
                                            setFieldsValue({  lastRentEndDate: endDate });

                                        
                                            let collect = ['lastRentStartDate', 'monthlyFee', 'networkFee', 'propertyFee'];
                                            let {lastRentStartDate} = getFieldsValue(collect);
                                            if (lastRentStartDate) {
                                                this.computeScatteredMoney({lastRentStartDate: lastRentStartDate});
                                            }
                                        }
                                    }}
                                >
                                    <RadioButton value={3}>3个月</RadioButton>
                                    <RadioButton value={6}>6个月</RadioButton>
                                    <RadioButton value={12}>12个月</RadioButton>
                                </RadioGroup>
                            )}
                        </div>
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="常规押金" subfix={<div>元</div>} subfixRight={30}>
                            {getFieldDecorator('normalDeposit', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.normalDeposit
                            })(
                                <InputNumber
                                    className="money-right"
                                    placeholder={'请输入'}
                                    min={0}
                                    style={{ paddingRight: '40px' }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="门卡押金" subfix={<div>元</div>} subfixRight={30}>
                            {getFieldDecorator('doorCardDeposit', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.doorCardDeposit
                            })(
                                <InputNumber
                                    className="money-right"
                                    placeholder={'请输入'}
                                    min={0}
                                    style={{ paddingRight: '40px' }}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="租金" subfix={<div>元/月</div>} subfixRight={30}>
                            {getFieldDecorator('monthlyFee', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.monthlyFee
                            })(
                                <InputNumber
                                    className="money-right"
                                    placeholder={'请输入'}
                                    min={0}
                                    style={{ paddingRight: '60px' }}
                                    onChange={(value) => {
                                        this.computeScatteredMoney({ monthlyFee: value });
                                    }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="宽带费" subfix={<div>元/月</div>} subfixRight={30}>
                            {getFieldDecorator('networkFee', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.networkFee
                            })(
                                <InputNumber
                                    className="money-right"
                                    placeholder={'请输入'}
                                    min={0}
                                    style={{ paddingRight: '60px' }}
                                    onChange={(value) => {
                                        this.computeScatteredMoney({ networkFee: value });
                                    }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="物业费" subfix={<div>元/月</div>} subfixRight={30}>
                            {getFieldDecorator('propertyFee', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.propertyFee
                            })(
                                <InputNumber
                                    className="money-right"
                                    placeholder={'请输入'}
                                    min={0}
                                    style={{ paddingRight: '60px' }}
                                    onChange={(value) => {
                                        this.computeScatteredMoney({ propertyFee: value });
                                    }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="零散租期">
                            {getFieldDecorator('firstLastRentType', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.firstLastRentType
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                    onChange={this.handleFirstLastRentTypeChange}
                                >
                                    <Option value={1}>不设置</Option>
                                    <Option value={2}>设置零散租期</Option>
                                </Select>
                            )}
                        </CustomCol>
                    </CustomRow>
                    {
                        isSetFirstEnd && (
                            <React.Fragment>
                                <CustomRow title divider>
                                    <CustomCol label="首期">
                                        <div className="datePickerNopadding" style={{ display: 'flex' }}>
                                            {getFieldDecorator('firstRentStartDate', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                                initialValue: data.firstRentStartDate
                                            })(
                                                <DatePicker
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span />}
                                                    disabled
                                                />
                                            )}
                                            <span style={{ padding: '0 5px' }}>至</span>
                                            {getFieldDecorator('firstRentEndDate', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                            })(
                                                <DatePicker
                                                    disabledDate={this.startDisabledDate}
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span />}
                                                    onChange={(value) => {
                                                        this.computeScatteredMoney({ firstRentEndDate: value });
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </CustomCol>
                                    <CustomCol label="租金" subfix={<div>元</div>} subfixRight={30}>
                                        {getFieldDecorator('firstRentFee', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                        })(
                                            <InputNumber
                                                className="money-right"
                                                placeholder={'请输入'}
                                                style={{ paddingRight: '40px' }}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="宽带费" subfix={<div>元</div>} subfixRight={30}>
                                        {getFieldDecorator('firstRentNetworkFee', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                        })(
                                            <InputNumber
                                                className="money-right"
                                                placeholder={'请输入'}
                                                style={{ paddingRight: '40px' }}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="物业费" subfix={<div>元</div>} subfixRight={30}>
                                        {getFieldDecorator('firstRentPropertyFee', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                        })(
                                            <InputNumber
                                                className="money-right"
                                                placeholder={'请输入'}
                                                style={{ paddingRight: '40px' }}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow title divider>
                                    <CustomCol label="末期">
                                        <div className="datePickerNopadding" style={{ display: 'flex' }}>
                                            {getFieldDecorator('lastRentStartDate', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                            })(
                                                <DatePicker
                                                    disabledDate={this.startDisabledDate}
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span />}
                                                    onChange={(value) => {
                                                        this.computeScatteredMoney({ lastRentStartDate: value });
                                                    }}
                                                />
                                            )}
                                            <span style={{ padding: '0 5px' }}>至</span>
                                            {getFieldDecorator('lastRentEndDate', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                                initialValue: data.lastRentEndDate
                                            })(
                                                <DatePicker
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span />}
                                                    disabled
                                                />
                                            )}
                                        </div>
                                    </CustomCol>
                                    <CustomCol label="租金" subfix={<div>元</div>} subfixRight={30}>
                                        {getFieldDecorator('lastRentFee', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                        })(
                                            <InputNumber
                                                className="money-right"
                                                placeholder={'请输入'}
                                                style={{ paddingRight: '40px' }}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="宽带费" subfix={<div>元</div>} subfixRight={30}>
                                        {getFieldDecorator('lastRentNetworkFee', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                        })(
                                            <InputNumber
                                                className="money-right"
                                                placeholder={'请输入'}
                                                style={{ paddingRight: '40px' }}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="物业费" subfix={<div>元</div>} subfixRight={30}>
                                        {getFieldDecorator('lastRentPropertyFee', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                        })(
                                            <InputNumber
                                                className="money-right"
                                                placeholder={'请输入'}
                                                style={{ paddingRight: '40px' }}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            </React.Fragment>
                        )
                    }
                    <CustomRow title divider>
                        <CustomCol label="付款日">
                            {getFieldDecorator('payDay', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.payDay
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                >
                                    {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="房间物品" required={false} labelStyle={{ height: '100px' }} colStyle={{ width: '1100px', height: '100px' }}>
                            <a
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    height: '100%',
                                    padding: '11px',
                                    lineHeight: '20px',
                                    color: data.furnitureList && data.furnitureList instanceof Array && data.furnitureList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                                    overflowY: 'auto'
                                }}
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.handleGoodsChange()
                                }}
                            >
                                {
                                    data.furnitureList && data.furnitureList instanceof Array && data.furnitureList.length
                                        ? data.furnitureList.map((item, index) => {
                                            return `${item.name}${item.amount > 1 ? 'X' + item.amount : ''}${index < data.furnitureList.length - 1 ? '、' : ''}`
                                        })
                                        : '请选择'
                                }
                            </a>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="合同补充条款" required={false} labelStyle={{ height: '100px' }} colStyle={{ width: '1100px', height: '100px' }}>
                            {getFieldDecorator('contractRemark', {
                                initialValue: data.contractRemark
                            })(
                                <TextArea
                                    style={{ height: '100%', padding: '11px', lineHeight: '20px' }}
                                    placeholder="显示在合同补充条款中，最多500字"
                                    maxLength={500}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <div className="hr" />
                    <CustomRow title="办理" divider>
                        <CustomCol label="签约类型">
                            {getFieldDecorator('contractType', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.contractType || signType
                            })(
                                <Select
                                    showSearch
                                    disabled={createElectronicContract === 'false'}
                                    placeholder="请选择"
                                    onChange={(value) => {
                                        this.setState({ signType: value });
                                    }}
                                    optionFilterProp={'children'}
                                >
                                    {contractType.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol label="合同编号" required={false}>
                            {getFieldDecorator('contractNo', {
                                initialValue: data.contractNo
                            })(
                                <Input
                                    autoComplete={"off"}
                                    placeholder="请输入"
                                />
                            )}
                        </CustomCol>
                        {
                            signType === 1
                                ? <React.Fragment>
                                    <CustomCol label="电子合同" required={false}>
                                        {getFieldDecorator('contractTemplateId', {
                                            initialValue: contractData.id
                                        })(
                                            <Input type={'hidden'} />
                                        )}
                                        <Input disabled value={contractData.name} placeholder="未设置，请使用纸质合同签约" />
                                    </CustomCol>
                                    <div className="center" style={{ marginLeft: '10px' }}>
                                        <span className="showClickDetail" onClick={
                                            () => { this.setState({ downloadUrl: contractData.fileUrl }, () => { this.downloadRef.click() }); }}
                                        >预览合同模板</span>
                                        <a href={downloadUrl} target="_block" download ref={ref => this.downloadRef = ref} style={{ display: 'none' }} >-</a>
                                    </div>
                                </React.Fragment>
                                : signType === 2
                                    ? <React.Fragment>
                                        <CustomCol label="纸质合同" colStyle={{ width: '460px' }}>
                                            {getFieldDecorator('paperAttachList', {
                                                rules: [{
                                                    required: !(data.paperAttachList instanceof Array && data.paperAttachList.length), message: '请上传纸质合同',
                                                }],
                                            })(
                                                <Input type="hidden" />
                                            )}
                                            <span
                                                style={{
                                                    display: 'block',
                                                    width: '100%',
                                                    padding: '0 11px',
                                                    height: '100%',
                                                    color: data.paperAttachList instanceof Array && data.paperAttachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                                                    whiteSpace: 'nowrap',
                                                    overflowX: 'auto',
                                                    overflowY: 'hidden',
                                                }}
                                            >
                                                {
                                                    data.paperAttachList instanceof Array && data.paperAttachList.length
                                                        ? data.paperAttachList.map((item, index) => {
                                                            return <span key={index}>
                                                                <a
                                                                    href={item.url}
                                                                    download
                                                                    className="showClickDetail"
                                                                    style={{ color: 'inherit' }}
                                                                    target="_blank"
                                                                >{item.name}；</a>
                                                                <Popconfirm
                                                                    placement="topRight"
                                                                    title={'此删除操作不可恢复，确定删除吗？'}
                                                                    onConfirm={() => {
                                                                        this.handleDeleteContract(index)
                                                                    }}
                                                                    okText="删除"
                                                                    cancelText="取消"
                                                                >
                                                                    <span style={{ cursor: 'pointer', marginRight: '10px' }} title="删除">
                                                                        <Icon type="close" />
                                                                    </span>
                                                                </Popconfirm>
                                                            </span>
                                                        })
                                                        : "未上传"
                                                }
                                            </span>
                                        </CustomCol>
                                        <div className="center" style={{ marginLeft: '10px', height: '34px' }}>
                                            <Upload {...uploadEnclosure({ accept: '', tableName: 'rent_contract', success: this.uploadContract, attachType: 5 })}>
                                                <span className="showClickDetail">上传</span>
                                            </Upload>
                                        </div>
                                    </React.Fragment>
                                    : null
                        }
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="附件" required={false} colStyle={{ width: '460px' }}>
                            <span
                                style={{
                                    display: 'block',
                                    padding: '0 11px',
                                    height: '100%',
                                    color: data.attachList instanceof Array && data.attachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                                    whiteSpace: 'nowrap',
                                    overflowX: 'auto',
                                    overflowY: 'hidden',
                                }}
                            >
                                {
                                    data.attachList instanceof Array && data.attachList.length
                                        ? data.attachList.map((item, index) => {
                                            return <span key={index}>
                                                <a
                                                    href={item.url}
                                                    download
                                                    className="showClickDetail"
                                                    style={{ color: 'inherit' }}
                                                    target="_blank"
                                                >{item.name}；</a>
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={'此删除操作不可恢复，确定删除吗？'}
                                                    onConfirm={() => {
                                                        this.handleDeleteAttach(index)
                                                    }}
                                                    okText="删除"
                                                    cancelText="取消"
                                                >
                                                    <span style={{ cursor: 'pointer', marginRight: '10px' }} title="删除">
                                                        <Icon type="close" />
                                                    </span>
                                                </Popconfirm>
                                            </span>

                                        })
                                        : "未上传"
                                }
                            </span>
                        </CustomCol>
                        <div className="center" style={{ marginLeft: '10px' }}>
                            <Upload {...uploadEnclosure({ accept: '', tableName: 'rent_contract', success: this.uploadEnclosure })}>
                                <span className="showClickDetail">上传</span>
                            </Upload>
                        </div>
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="办理部门">
                            {getFieldDecorator('createMerchantDepartmentId', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: this.loginData ? this.loginData.departmentId : data.createMerchantDepartmentId
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    onChange={(value) => { //部门
                                        this.postUserGet(value)
                                    }}
                                    optionFilterProp={'children'}
                                >
                                    {departmentData.map((item, index) => <Option value={item.id} key={item.id}>{item.name}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol divider label="办理人">
                            {getFieldDecorator('createMerchantUserId', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: this.loginData ? this.loginData.id : data.createMerchantUserId
                            })(
                                <Select
                                    showSearch

                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                >
                                    {userData.map((item, index) => <Option value={item.id} key={item.id}>{item.name}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol divider label="办理日期">
                            {getFieldDecorator('signDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.signDate ? moment(data.signDate) : moment()
                            })(
                                <DatePicker
                                    placeholder={'请选择'}

                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title divider>
                        <CustomCol label="办理备注" required={false} colStyle={{ width: '1100px' }}>
                            {getFieldDecorator('remark', {
                                initialValue: data.remark
                            })(
                                <Input
                                    autoComplete={"off"}
                                    placeholder="请输入"
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                </Form>

                <ChooseGoods onRef={ref => this.chooseGoodsRef = ref} />
            </div>
        </ModalDom >
    }
}

export default Form.create()(LeaseSigning);


// WEBPACK FOOTER //
// ./src/containers/LeaseSigning/index.js